import React from 'react';
import PostSummary from './PostSummary';
import { Link } from 'react-router-dom';
import CreatePost from './CreatePost';

const PostsList = ({ posts, profile, auth, users }) => {
    

    return (
        <div className="feed-list">
            <div className="section">
                { posts && posts.map(post => {
                    return (
                        <PostSummary post={post} profile={profile} auth={auth} users={users} key={post.id} />
                    )
                })}
            </div>
        </div>
    )
};

export default PostsList;